import {
  ApiResponse,
  Feature,
  FeatureCategory,
  FeatureCategoryId,
  FeatureCategoryPostRequest,
  FeaturePatchRequest,
  FeaturePostRequest,
  PropertyFeatureId,
  PropertyFeatures,
  PropertyId,
  PropertySlug,
} from '@arrived/models';

import { api } from './api';
import { unwrapApiResponse } from './utils';

export const getPropertyFeatures = async (propertyId: PropertyId) => {
  const response = await api.get<ApiResponse<PropertyFeatures>>(`/properties/${propertyId}/features`);

  return unwrapApiResponse(response.data);
};

export const getListedPropertyFeatures = async (slug: PropertySlug) => {
  const response = await api.get<ApiResponse<PropertyFeatures>>(`/properties/listed/${slug}/features`);

  return unwrapApiResponse(response.data);
};

export const getAllPropertyFeatures = async () => {
  const response = await api.get<ApiResponse<Feature[]>>('/properties/features');

  return unwrapApiResponse(response.data);
};

export const postPropertyFeature = async (request: FeaturePostRequest) => {
  const response = await api.post<ApiResponse<Feature>>('/properties/features', request);

  return unwrapApiResponse(response.data);
};

export const patchPropertyFeature = async (request: FeaturePatchRequest) => {
  const response = await api.patch<ApiResponse<Feature>>(`/properties/features/${request.id}`, request);

  return unwrapApiResponse(response.data);
};

export const deletePropertyFeature = async (featureId: PropertyFeatureId) => {
  const response = await api.delete<ApiResponse<Feature>>(`/properties/features/${featureId}`);

  return unwrapApiResponse(response.data);
};

export const getPropertyFeatureCategories = async () => {
  const response = await api.get<ApiResponse<FeatureCategory>>('/properties/features/categories');

  return unwrapApiResponse(response.data);
};

export const postPropertyFeatureCategory = async (request: FeatureCategoryPostRequest) => {
  const response = await api.post<ApiResponse<FeatureCategory>>('/properties/features/categories', request);

  return unwrapApiResponse(response.data);
};

export const patchPropertyFeatureCategory = async (request: FeatureCategory) => {
  const response = await api.patch<ApiResponse<FeatureCategory>>(
    `/properties/features/categories/${request.id}`,
    request
  );

  return unwrapApiResponse(response.data);
};

export const deletePropertyFeatureCategory = async (featureCategoryId: FeatureCategoryId) => {
  const response = await api.delete<ApiResponse<FeatureCategory>>(
    `/properties/features/categories/${featureCategoryId}`
  );

  return unwrapApiResponse(response.data);
};

export const addFeatureToProperty = async (propertyId: PropertyId, featureId: PropertyFeatureId) => {
  const response = await api.post<ApiResponse<PropertyFeatures>>(`/properties/${propertyId}/features/${featureId}`);

  return unwrapApiResponse(response.data);
};

export const deleteFeatureFromProperty = async (propertyId: PropertyId, featureId: PropertyFeatureId) => {
  const response = await api.delete<ApiResponse<PropertyFeatures>>(`/properties/${propertyId}/features/${featureId}`);

  return unwrapApiResponse(response.data);
};
